const basicManagement = () => import("@/pages/basic/index")
const carouselManagement = () => import("@/pages/basic/carousel/list")
const carouselEditor = () => import("@/pages/basic/carousel/editor")
const navigationManagement = () => import("@/pages/basic/navigation/list")
const examineManagement = () => import("@/pages/basic/examine/list")

export default [
    {
        path: '/basic-management',
        component: basicManagement,
        children: [
            {
                path: 'carousel',
                component: carouselManagement,
                meta: [
                    {
                        name: '轮播图管理',
                        url: ''
                    }
                ]
            },
            {
                path: 'carousel/add',
                component: carouselEditor,
                meta: [
                    {
                        name: '轮播图管理',
                        url: '/basic-management/carousel'
                    },
                    {
                        name: '新增轮播图',
                        url: 'add'
                    }
                ]
            },
            {
                path: 'carousel/set/:id',
                component: carouselEditor,
                meta: [
                    {
                        name: '轮播图管理',
                        url: '/basic-management/carousel'
                    },
                    {
                        name: '编辑轮播图',
                        url: 'set'
                    }
                ]
            },
            {
                path: 'navigation',
                component: navigationManagement,
                meta: [
                    {
                        name: '导航设置',
                        url: ''
                    }
                ]
            },
            {
                path: 'examine',
                component: examineManagement,
                meta: [
                    {
                        name: '项目品鉴',
                        url: ''
                    }
                ]
            },
        ]
    }
]


// WEBPACK FOOTER //
// ./src/router/basic.js